import { render, staticRenderFns } from "./LanguageDropDown.vue?vue&type=template&id=4fc8e86a&"
import script from "./LanguageDropDown.vue?vue&type=script&lang=js&"
export * from "./LanguageDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports